import styles from './LiveRowsSkeleton.module.css';

const ROWS = [0, 1, 2, 3, 4, 5];

/** The outline of a list on its way: the same height as its rows, so the page
 *  stays put when they come. No prices, not even old ones. */
export const LiveRowsSkeleton = () => (
  <div className={styles.list} aria-hidden="true" data-testid="live-skeleton">
    {ROWS.map((x) => (
      <div className={styles.row} key={x}>
        <div className={styles.match}>
          <span className={styles.line} />
          <span className={styles.lineShort} />
        </div>
        <div className={styles.odds}>
          <span />
          <span />
          <span />
        </div>
      </div>
    ))}
  </div>
);
